const initialState = {
  loading: false,
  data: null,
  error: null,
};

const goalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_GOAL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_GOAL_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_GOAL_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default goalReducer;
